import { render, staticRenderFns } from "./ApproveDialog.vue?vue&type=template&id=30355c79&scoped=true"
import script from "./ApproveDialog.vue?vue&type=script&lang=js"
export * from "./ApproveDialog.vue?vue&type=script&lang=js"
import style0 from "./ApproveDialog.vue?vue&type=style&index=0&id=30355c79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30355c79",
  null
  
)

export default component.exports